import { SigmaSectorModel } from '@/domain/models'
import { GetSigmaDeskSectors } from '@/domain/usecases'
import { makeAxiosHttpClient } from '@/main/factories/http'
import { RemoteGetSigmaDeskSectors } from '@/data/usecases/events'
import env from '@/main/config/env'

export const makeGetSigmaDeskSectorsFactory = (): GetSigmaDeskSectors => {
  const url = env.API_URL
  const httpClient = makeAxiosHttpClient<SigmaSectorModel[]>()

  return new RemoteGetSigmaDeskSectors(url, httpClient)
}
